import { defineMessages, MessageDescriptor } from 'react-intl';

import { CalledVia } from '@/shared/api/protocol-ts/model/dto_base_pb';

import { CompanyInfoTitles, TabValue } from './constants';

export const companyInfoTitles = defineMessages<CompanyInfoTitles>({
  [CompanyInfoTitles.City]: {
    id: 'global.city',
    defaultMessage: 'City',
  },
  [CompanyInfoTitles.Address]: {
    id: 'global.address',
    defaultMessage: 'Address',
  },
  [CompanyInfoTitles.Phones]: {
    id: 'companyInfo.phone',
    defaultMessage: 'Phone',
  },
  [CompanyInfoTitles.WebSite]: {
    id: 'companyInfo.Website',
    defaultMessage: 'Website',
  },
  [CompanyInfoTitles.Country]: {
    id: 'CompanyInfo.Country',
    defaultMessage: 'Country',
  },
  [CompanyInfoTitles.Emails]: {
    id: 'companyInfo.workEmail',
    defaultMessage: 'Work Email',
  },
  [CompanyInfoTitles.ZipCode]: {
    id: 'global.zipCode',
    defaultMessage: 'ZIP code',
  },
  [CompanyInfoTitles.Region]: {
    id: 'global.region',
    defaultMessage: 'Region',
  },
});

export const companySettingsTabLabels = defineMessages<TabValue>({
  [TabValue.CompanyInfo]: {
    id: 'companySettings.tab.clinicInfo',
    defaultMessage: 'Clinic info',
  },
  [TabValue.Staff]: {
    id: 'companySettings.tab.team',
    defaultMessage: 'Team',
  },
  [TabValue.Templates]: {
    id: 'controlPanel.templates',
    defaultMessage: 'Templates',
  },
  [TabValue.Analytics]: {
    id: 'companySettings.tab.analytics',
    defaultMessage: 'Tags',
  },
  [TabValue.BillingInfo]: {
    id: 'companySettings.tab.billingInfo',
    defaultMessage: 'Billing info',
  },
  [TabValue.SubscriptionPlans]: {
    id: 'companySettings.tab.subscriptionPlans',
    defaultMessage: 'Subscription plans',
  },
  [TabValue.APIKeys]: {
    id: 'companySettings.tab.apiKeys',
    defaultMessage: 'API keys',
  },
});

export const analyticsEditorMessages = defineMessages({
  loadError: {
    id: 'analyticsModel.editor.loadError',
    defaultMessage: 'Failed to load the analytics model',
  },
});

// CalledViaUnspecified has no label — rendered as EMPTY_VALUE, hence Partial.
export const apiKeyCalledViaLabels: Partial<
  Record<CalledVia, MessageDescriptor>
> = defineMessages({
  [CalledVia.CalledViaClient]: {
    id: 'companySettings.apiKeys.via.client',
    defaultMessage: 'Client',
  },
  [CalledVia.CalledViaPartnerAPI]: {
    id: 'companySettings.apiKeys.via.partnerApi',
    defaultMessage: 'Partner API',
  },
  [CalledVia.CalledViaMLPipelines]: {
    id: 'companySettings.apiKeys.via.mlPipelines',
    defaultMessage: 'ML Pipelines',
  },
});
